export default function () {
  this.route("community-wishes", { path: "/mod-wishes" });
}
